import { Button, CircularProgress, TextField } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { getUserProfile, updateUserProfile } from '../../api_helper/api';
import SnackbarAlertContext from '../../context/SnackbarAlertContext';

const ChatbotSettings = () => {
	const snackbarAlertContext = useContext(SnackbarAlertContext);

	const [chatbotRules, setChatbotRules] = useState();
	const [isSaving, setIsSaving] = useState(false);

	const saveButtonClickHandler = async () => {
		try {
			setIsSaving(true);
			await updateUserProfile({ chatbotRules });
			setIsSaving(false);
			snackbarAlertContext.setSnackbarAlert({
				isSnackbarOpen: true,
				autoHide: 3000,
				msg: 'Chatbot rules saved successfully',
				severity: 'success',
			});
		} catch (error) {
			snackbarAlertContext.setSnackbarAlert({
				isSnackbarOpen: true,
				autoHide: 3000,
				msg: 'There was an error saving your chatbot rules. Please try again later.',
				severity: 'error',
			});
		}
	};

	useEffect(() => {
		const fetchChatbotRules = async () => {
			const userProfile = await getUserProfile();
			setChatbotRules(userProfile.chatbotRules || '');
		};
		fetchChatbotRules();
	}, []);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', maxWidth: '80rem', margin: '0 auto' }}>
			<h3 style={{ marginBottom: '0' }}>Chatbot Rules</h3>
			<p style={{ marginBottom: '1.5rem', fontSize: '0.8rem', color: 'gray' }}>
				These preferences get sent to the SportWise chatbot on all chats.
			</p>
			{chatbotRules === undefined ? (
				<CircularProgress color="inherit" />
			) : (
				<TextField
					disabled={isSaving}
					value={chatbotRules}
					onChange={(e) => setChatbotRules(e.target.value)}
					multiline
          minRows={4}
					placeholder="Enter your chatbot rules here"
				/>
			)}
			<Button
				variant="contained"
				color="secondary"
				style={{ width: 'fit-content', marginTop: '1rem' }}
				onClick={saveButtonClickHandler}
			>
				Save
			</Button>
		</div>
	);
};

export default ChatbotSettings;
